import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { Disclosure } from "@headlessui/react";
import { Caret, SvgIndicatorResponse } from "@routes/IconeSvg";
import { DisclosureContentFluid } from "@components/TransitionFluid";
import Button from "@components/tailwindComponents/Button";
import { Status } from "@components/tailwindComponents";
import { getAmount,  getStatusColor } from "@helpers/_functions";
import moment from "moment-timezone";
import BlackTooltip from "@components/tooltip/BlackTooltip";
import SharedViewFile from "@components/modals/SharedViewFile";
import ModalComments from "../../components/modals/Comments"; 
import ModalMileinageRequest from "../../components/modals/MileageRequest";
import ModalDelete from "../../components/modals/DeleteReimburment";
import ModalNewRequest from "../../components/modals/NewRequest";
import { isEqual } from "lodash";
import { useReimbursement } from "@hooks/reimbursments/useReimbursement";
import Description from "@components/tailwindComponents/Description";

function ItemsCardMobile({
  expense:reimbursment,
  i18n,
  defaultOpen = false,
  isDraft = false
}) {
  const [showModalComments, setShowModal] = useState(false);
  const [sharedViewFile, setShowFile] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showModalRequest, setShowNewRequest] = useState(false);
  const [showModalMileiageRequest, setShowNewMileaigeRequest] = useState(false);
  const [file, setFile] = useState({});
  const { t } = useTranslation("expenses.reimbursment");
  const onClickShowFile = (file) => {
    setShowFile(!sharedViewFile);
    setFile(file);
  };
  const { onDelete } = useReimbursement();
  const onToggleComments = () => {
    setShowModal(!showModalComments);
  };

  const OnClickEditReimbursment = () => {
    if( isEqual(reimbursment?.type,"mileage")){
      setShowNewMileaigeRequest((_showModalMileiageRequest) => !_showModalMileiageRequest);
    }else{
      setShowNewRequest((_showModalRequest) => !_showModalRequest);
    }
 
  }

  const onClickDelete = () => {
    setShowDelete(!showDelete);
  };
  return (
    <>
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button
              className={
                isDraft
                  ? "arh-flex arh-w-full arh-flex-col arh-border-0 arh-bg-white arh-px-[0.5rem] arh-pb-[1rem]"
                  : open
                  ? "arh-flex arh-w-full  arh-flex-col arh-rounded-tl-[6px] arh-rounded-tr-[6px] arh-border arh-border-b-0 arh-border-solid arh-border-[#D7D7D7] arh-bg-white arh-px-[0.5rem] arh-pb-[1rem] "
                  : "arh-flex arh-w-full  arh-flex-col arh-rounded-[6px] arh-border arh-border-solid arh-border-[#D7D7D7] arh-bg-white arh-px-[0.5rem] arh-pb-[1rem] "
              }
            >
              <div className="arh-flex arh-w-full arh-items-center arh-justify-between">
                <div className="arh-flex arh-items-center arh-space-x-4 arh-p-4 ">
                  <div
                    className={`arh-transform" arh-flex arh-transition arh-duration-[100ms] arh-ease-in`}
                  >
                    <Caret
                      className={`${open ? "arh-rotate-90" : "arh-rotate-0"}`}
                    />
                  </div>

                  <span className="arh-ml-0 arh-text-xs arh-font-poppins  arh-font-medium  arh-text-darkColor">
                  {reimbursment?.category?.name}
                  </span>
                </div>
                <div className="arh-mr-4"> 
                <Status className={getStatusColor(reimbursment.status)} />
                </div>
              </div>
              <div className="arh-mb-[0.5rem] arh-flex arh-w-full arh-items-center arh-justify-between arh-px-[2.3rem]">
                <span className="arh-w-1/2 arh-text-left arh-text-darkColor arh-text-xs arh-font-poppins  arh-font-medium ">
                  {t("Date")} 
                 </span>
                <span className="arh-w-1/2 arh-truncate arh-text-right arh-text-[#828896] arh-font-normal arh-text-xs arh-font-poppins ">
                  {moment(reimbursment?.date, "YYYY-MM-DD")
                    .locale(i18n.language)
                    .format("LL"
                    )} 
                </span>
              </div>
              <div className="arh-mb-[0.5rem] arh-flex arh-w-full arh-items-center arh-justify-between arh-px-[2.3rem]">
                <span className="arh-w-1/2 arh-text-left arh-text-darkColor arh-text-xs arh-font-poppins arh-font-medium">
                {t("Montant")}
                </span>
                <span className="arh-w-1/2 arh-truncate arh-text-right arh-text-[#828896] arh-text-xs arh-font-poppins arh-font-normal">
                {reimbursment?.devise || "$ "} {getAmount(reimbursment)}
                </span>
              </div>
            </Disclosure.Button>
            <DisclosureContentFluid
              open={open}
              superZIndex={
                isDraft
                  ? "arh-bg-white !arh-m-0 arh-px-[0.5rem]"
                  : open
                  ? "arh-border arh-border-t-0 arh-border-solid arh-border-[#D7D7D7] arh-bg-white arh-rounded-bl-[6px] arh-rounded-br-[6px] !arh-m-0 arh-p-[0.5rem]"
                  : ""
              }
            >
              <Disclosure.Panel unmount={false}>
                <div className=" arh-flex arh-flex-col arh-space-y-1"> 
                <div className="arh-flex arh-w-full arh-items-center  arh-justify-between arh-bg-[#F9FAFC] arh-text-darkColor arh-px-[2.3rem] arh-py-[0.8rem]">
                  <span className="arh-w-1/2 arh-shrink-0 arh-text-left arh-text-darkColor arh-text-xs arh-font-poppins arh-font-medium  ">
                  {t("Description")}
                  </span>
                  <span className="arh-w-1/2 arh-min-w-0 arh-truncate arh-whitespace-nowrap arh-text-right arh-text-[#828896] arh-text-xs arh-font-poppins arh-font-normal">
                  {reimbursment?.description || "-"}
                  </span>
                </div>
                <div className="arh-flex arh-w-full arh-items-center arh-justify-between arh-bg-[#F9FAFC] arh-px-[2.3rem] arh-py-[0.8rem]">
                  <span className="arh-w-1/2 arh-shrink-0 arh-text-left arh-text-darkColor arh-text-xs arh-font-poppins arh-font-medium ">
                  {t("Fichier joint")}
                  </span>
                  <span className="arh-w-1/2 arh-min-w-0 arh-truncate arh-whitespace-nowrap arh-text-right arh-text-[#828896] arh-text-xs arh-font-poppins arh-font-normal">
                  {reimbursment?.files?.length
                    ? reimbursment.files.map((file, index) => (
                        <BlackTooltip
                          title={file?.filename}
                          placement="top"
                          key={file._id}
                        >
                          <span className="arh-truncate arh-w-full arh-block arh-cursor-pointer"  onClick={() => onClickShowFile(file)}>  {/* onClick={(e) =>  window.open(file?.location, "_blank")} */}
                              {file?.filename}
                          </span>
                        </BlackTooltip>
                      ))
                    : "-"}
                  </span>
                </div>
                <div className="arh-flex arh-w-full arh-items-center arh-justify-between arh-bg-[#F9FAFC] arh-px-[2.3rem] arh-py-[0.8rem]">
                  <span className="arh-w-1/2 arh-shrink-0 arh-text-left arh-text-darkColor arh-text-xs arh-font-poppins arh-font-medium">
                  {t("Commentaire")}
                  </span>
                  <div className="arh-flex arh-h-full arh-w-1/2 arh-min-w-0 arh-items-center arh-justify-end arh-space-x-4 arh-overflow-hidden arh-whitespace-nowrap arh-text-right" onClick={onToggleComments}>
                    {reimbursment?.commentSended || reimbursment?.commentReceived ? (
                      <Description
                        description={reimbursment?.commentSended || reimbursment?.commentReceived}
                        className="arh-font-poppins arh-font-normal arh-text-xs arh-cursor-pointer"
                        textColor="arh-text-[#828896]"
                      />
                    ) : (
                      "-"
                    )}
                    <span>
                      {reimbursment?.commentReceived ? SvgIndicatorResponse() : ""}
                    </span>
                  </div>
                </div>
                <div className="arh-flex arh-w-full arh-items-center arh-justify-between arh-bg-[#F9FAFC] arh-px-[2.3rem] arh-py-[0.8rem]">
                  <span className="arh-w-1/2 arh-shrink-0 arh-text-left arh-text-darkColor arh-text-xs arh-font-poppins arh-font-medium">
                  {t("Statut")} :
                  </span>
                  <div className="arh-flex arh-w-1/2 arh-min-w-0 arh-justify-end arh-items-center arh-space-x-4">
                    <div className="arh-flex arh-shrink-0 arh-items-center arh-rounded arh-border arh-border-solid arh-border-greyBorderInput arh-px-4 arh-py-2 arh-whitespace-nowrap">
                      <Status
                          className={`arh-mr-[10%] ${getStatusColor(
                          reimbursment.status,
                          )}`}
                      />
                      <span className="arh-align-middle arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor">
                          {t(reimbursment.status)}
                      </span>
                    </div>
                   </div>
                </div>
                {
                  isEqual(reimbursment.status,"waiting") || isEqual(reimbursment.status,"draft") ? (
                  <Button
                    variant={reimbursment.status === "draft" ? "green-outlined" : "green"}
                    padding={reimbursment.status === "draft" ? "arh-px-3 arh-py-2" : undefined}
                    className={reimbursment.status === "draft" ? "!arh-rounded-[4px]" : ""}
                    onClick={OnClickEditReimbursment}
                  >
                    {t(reimbursment.status === "draft" ? "Compléter" : "Modifier")}

                  </Button>) :""
                }
                 {!isEqual(reimbursment.status, "accepted") ? (
                <Button variant="outlined" onClick={onClickDelete}>
                  {t(reimbursment.status === "draft" ? "Effacer" : "Supprimer")}
                </Button>):""}
                </div>
              </Disclosure.Panel>
            </DisclosureContentFluid>
          </>
        )}
      </Disclosure>

      <SharedViewFile
        onClickClose={onClickShowFile}
        show={sharedViewFile}
        file={file}
        t={t}
      />
      <ModalDelete
        onClickClose={onClickDelete}
        onDeleteClick={() => onDelete(reimbursment?._id)}
        show={showDelete}
        t={t}
      />
      <ModalComments
        show={showModalComments}
        onClickClose={onToggleComments}
        commentSended={reimbursment?.commentSended}
        commentReceived={reimbursment?.commentReceived}
        statusTitle={reimbursment.status}
        t={t}
      />
       <ModalNewRequest
        show={showModalRequest}
        onClickClose={OnClickEditReimbursment}
        reimbursment={reimbursment}
      />

      <ModalMileinageRequest
        isOpen={showModalMileiageRequest}
        onClickClose={OnClickEditReimbursment}
        t={t}
        reimbursment={reimbursment}
      />
    </>
  );
}

export default ItemsCardMobile;
